import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { User } from '../../../models/user';
import { UserService } from '../../../services/user.service';
import { switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ROLE_ADMIN_ID, ROLE_OWNER_ID } from '../../../models/role';
import { SessionStorageService } from 'ngx-webstorage';
import { AtlasToastService } from '../../../services/atlas-toast.service';
import { ToastContainerDirective } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl } from '@angular/forms';
import { PrivacySettingModalComponent } from '../privacy-setting-modal/privacy-setting-modal.component';
import { MenuService } from '@services/menu.service';
import { SMS_SENDERS } from '@models/menu-entries';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LoaderService } from '@services/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wsb-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('displayDashboard', [
      state('loading', style({ opacity: '0' })),
      state('loaded', style({ opacity: '1' })),
      transition('loading => loaded', [animate('300ms ease-in')])
    ])
  ],
  standalone: false
})
export class DashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('pageDashboard', { static: true }) $pageDashboard;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  private privacySettingModal: NgbModalRef;

  private readonly brandNamesPrivacy = ['skebby', 'mobyt', 'trendoo', 'aruba', 'lowcost', 'default'];

  whatsAppBannerLink;
  senderAppBannerLink;

  showBanner = false;
  showSenderBanner = false;
  banner;
  senderBanner;
  dashboardState = 'loading';
  brand;

  user: User | null;

  hasSupportGuideUrl = false;
  hasRegistrationMail = false;
  menuEntries;

  toastCheck = new UntypedFormControl(false);

  private menuEntriesSubsc: Subscription = new Subscription();

  constructor(
    private userService: UserService,
    private translateService: TranslateService,
    private sessionStorage: SessionStorageService,
    private loaderService: LoaderService,
    private atlasToastService: AtlasToastService,
    private modalService: NgbModal,
    private cdRef: ChangeDetectorRef,
    private menuService: MenuService
  ) {}

  ngOnInit() {
    this.loaderService.show();
    this.brand = this.sessionStorage.retrieve('wsb-brand-name');

    this.translateService
      .get('support_guide_url')
      .subscribe(label => (this.hasSupportGuideUrl = label && label !== '' && label !== 'support_guide_url'));
    this.translateService.onLangChange
      .pipe(switchMap(() => this.translateService.get('support_guide_url')))
      .subscribe(label => (this.hasSupportGuideUrl = label && label !== '' && label !== 'support_guide_url'));
  }

  checkIfWhatsAppBannerIsToShow() {
    if (this.brand === 'mobyt' || this.brand === 'trendoo') {
      this.showBanner = true;
      this.banner = '\\assets\\images\\WhatsApp-banner.jpg';
      this.whatsAppBannerLink =
        'mailto:whatsappbusiness@esendex.it?subject=richiesta informazioni Whatsapp Business&' +
        'body=Vorrei ricevere maggiori informazioni in merito a Whatsapp Business';
      if (this.brand === 'mobyt') {
        this.translateService.onLangChange.pipe(switchMap(() => this.translateService.get('whats_app_link'))).subscribe(link => {
          this.whatsAppBannerLink = link;
        });
      }
    }

    if (this.brand === 'smsenvoi' || this.brand === 'mobytfr') {
      this.showBanner = true;
      this.banner = '\\assets\\images\\DT-3057-FRA-ENV-BNR-Banner-FY22Q3-LU-V4.jpg';
      this.whatsAppBannerLink =
        "mailto:contact@smsenvoi.com?subject=Demande d'informations Whatsapp Business&" +
        "body=Je souhaite recevoir plus d'informations sur Whatsapp Business";
    }
    if (this.brand === 'smsenvoi' || this.brand === 'mediaburst') {
      this.showSenderBanner = true;
      if (this.brand === 'smsenvoi') {
        this.senderBanner = '\\assets\\images\\ENV-WPG-Banner-in-WSB-platform-FY25Q2-JP.png';
        this.senderAppBannerLink =
          'https://www.smsenvoi.com/reglementation-relative-aux-noms-dexpediteur-personnalises-pour-lenvoi-de-sms-vers-lirlande/';
      } else {
        this.senderBanner = '\\assets\\images\\TA-WPG-Banner-in-WSB-platform-FY25Q2-JP.png';
        this.senderAppBannerLink = 'https://help.textanywhere.com/sender-id-regulations-when-sending-sms-to-ireland/';
      }
    }
  }

  checkBrandForPrivacyPopup() {
    if (this.brandNamesPrivacy.includes(this.brand)) {
      return true;
    }
    return false;
  }

  getLogedInUser() {
    this.userService.getAuthenticationState().subscribe(next => {
      this.user = next;
      if (this.user && !this.user.account.subaccount) {
        this.checkIfWhatsAppBannerIsToShow();
      }

      if (this.user && !this.user.account.subaccount) {
        if (!this.toastCheck.value) {
          this.toastCheck.setValue(true);
        }
      }
      this.cdRef.detectChanges();
    });
  }

  checkIfOpenPrivacyModal(openPopup) {
    if (!openPopup) {
      return;
    }
    if (this.user.preferences.hidePrivacyPopUpDate) {
      return;
    }
    this.openPrivacyPopup(this.user?.preferences?.messageObfuscationType);
  }

  checkMenuEntries() {
    const menuEntrie$ = this.menuService.getMenuEntriesState();
    this.menuEntriesSubsc.add(
      menuEntrie$.subscribe((entries: any) => {
        this.menuEntries = entries;

        if (this.menuEntries[SMS_SENDERS]) {
          this.checkIfOpenPrivacyModal(true);
        } else {
          this.checkIfOpenPrivacyModal(false);
        }
        this.unsubscribeMenuEntriesState();
      })
    );
  }

  // To avoid to multi call while privacy pop up is showed
  private unsubscribeMenuEntriesState() {
    this.menuEntriesSubsc.unsubscribe();
  }

  openPrivacyPopup(messageObfuscationType) {
    if (!this?.menuEntries[SMS_SENDERS]) {
      return;
    }
    if (this.user?.preferences?.hidePrivacyPopUpDate) {
      return;
    }

    if (!this.checkBrandForPrivacyPopup()) {
      return;
    }

    // case: Super not hide pop up privacy
    if (this.sessionStorage.retrieve('hide-privacy-setting-session')) {
      // check pop of the sub is displeyed
      if (!this.checkIfImpersonateSubWithShowPopPrivacy()) {
        return;
      }
    }

    // case: Super hide pop up privacy
    if (this.sessionStorage.retrieve('wsb-impersonate-subuser-key')) {
      if (!this.checkIfSubPopPrivacyisShowed()) return;
    }

    this.openPrivacySettingModal(messageObfuscationType);
  }

  private checkIfImpersonateSubWithShowPopPrivacy() {
    if (this.sessionStorage.retrieve('wsb-impersonate-subuser-key')) {
      return this.checkIfSubPopPrivacyisShowed();
    }
    return false;
  }

  private checkIfSubPopPrivacyisShowed() {
    if (this.sessionStorage.retrieve('hide-privacy-popup-impersonate-sub')) {
      return false;
    }
    return true;
  }

  ngAfterViewInit(): void {
    if (this.toastCheck.value) {
      this.atlasToastService.info('dashboard_intro_title', 'dashboard_intro_text', -1, this.toastContainer);
    } else {
      this.toastCheck.valueChanges.subscribe(() => {
        this.atlasToastService.info('dashboard_intro_title', 'dashboard_intro_text', -1, this.toastContainer);
      });
    }

    this.getLogedInUser();
    this.checkMenuEntries();
    // timeout to let the dashboard load
    setTimeout(() => {
      this.dashboardState = 'loaded';
      this.loaderService.hide();
    }, 400);
  }

  get showHelp(): boolean {
    return !this.userService.isSubaccount();
  }

  get showShop(): boolean {
    return (
      !this.userService.isSubaccount() &&
      (this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_OWNER_ID ||
        this.sessionStorage.retrieve('wsb-userprofile-role') === ROLE_ADMIN_ID)
    );
  }

  get getUserName(): string {
    if (this.user) {
      return this.user.profile.name;
    }
    return null;
  }

  openPrivacySettingModal(messageObfuscationType) {
    if (this.privacySettingModal) {
      return;
    }
    this.privacySettingModal = this.modalService.open(PrivacySettingModalComponent, { size: 'lg' });
    this.privacySettingModal.componentInstance.messageObfuscationType = messageObfuscationType;
    this.privacySettingModal.result.then(
      result => {
        if (result) {
          this.userService.setPrivacyPopUpDate().subscribe();
        }
        this.setKeyHidePopPrivacy();
      },
      reason => {
        if (reason) {
          this.userService.setPrivacyPopUpDate().subscribe();
        }
        this.setKeyHidePopPrivacy();
      }
    );
  }

  private setKeyHidePopPrivacy() {
    if (this.sessionStorage.retrieve('wsb-impersonate-subuser-key')) {
      this.sessionStorage.store('hide-privacy-popup-impersonate-sub', true);
    } else {
      this.sessionStorage.store('hide-privacy-setting-session', true);
    }
  }
}
